import { render, staticRenderFns } from "./LocationsSection.vue?vue&type=template&id=d67c4c10&scoped=true"
import script from "./LocationsSection.vue?vue&type=script&lang=js"
export * from "./LocationsSection.vue?vue&type=script&lang=js"
import style0 from "./LocationsSection.vue?vue&type=style&index=0&id=d67c4c10&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d67c4c10",
  null
  
)

export default component.exports